import { components } from "@apiSchema";
import { iPermissionFields, PermissionLevelEnum } from "@models/PermissionSection";
import { IRecommendedChart, RecommendedCharts, RecommendedChartTypeEnum } from "@models/RecommendedCharts";

export interface iFoodProfileRecommendedCharts extends iPermissionFields {
    data: IRecommendedChart[];
}

type API_Model = components["schemas"]["MacAndMenuTrendDataViewModelChainPermissionWrapper"];

interface iData {
    apiModel?: API_Model;
    searchQuery: string;
}

export class FoodProfileRecommendedCharts implements iFoodProfileRecommendedCharts {
    static readonly fakeData: iFoodProfileRecommendedCharts['data'] = [
        {
            id: 1,
            title: "Fake Chart 1",
            typeLabel: RecommendedChartTypeEnum.Mac,
            link: "https://www.google.com",
        },
        {
            id: 2,
            title: "Fake Chart 2",
            typeLabel: RecommendedChartTypeEnum.InstantChart,
            link: "https://www.google.com",
        },
        {
            id: 3,
            title: "Fake Chart 3",
            typeLabel: RecommendedChartTypeEnum.Mac,
            link: "https://www.google.com",
        },
        {
            id: 4,
            title: "Fake Chart 4",
            typeLabel: RecommendedChartTypeEnum.InstantChart,
            link: "https://www.google.com",
        },
        {
            id: 5,
            title: "Fake Chart 5",
            typeLabel: RecommendedChartTypeEnum.Mac,
            link: "https://www.google.com",
        },
        {
            id: 6,
            title: "Fake Chart 6",
            typeLabel: RecommendedChartTypeEnum.InstantChart,
            link: "https://www.google.com",
        },
        {
            id: 7,
            title: "Fake Chart 7",
            typeLabel: RecommendedChartTypeEnum.Mac,
            link: "https://www.google.com",
        },
        {
            id: 8,
            title: "Fake Chart 8",
            typeLabel: RecommendedChartTypeEnum.InstantChart,
            link: "https://www.google.com",
        },
        {
            id: 9,
            title: "Fake Chart 9",
            typeLabel: RecommendedChartTypeEnum.Mac,
            link: "https://www.google.com",
        },
        {
            id: 10,
            title: "Fake Chart 10",
            typeLabel: RecommendedChartTypeEnum.InstantChart,
            link: "https://www.google.com",
        },
        {
            id: 11,
            title: "Fake Chart 11",
            typeLabel: RecommendedChartTypeEnum.Mac,
            link: "https://www.google.com",
        },
        {
            id: 12,
            title: "Fake Chart 12",
            typeLabel: RecommendedChartTypeEnum.InstantChart,
            link: "https://www.google.com",
        },
        {
            id: 13,
            title: "Fake Chart 13",
            typeLabel: RecommendedChartTypeEnum.Mac,
            link: "https://www.google.com",
        },
        {
            id: 14,
            title: "Fake Chart 14",
            typeLabel: RecommendedChartTypeEnum.InstantChart,
            link: "https://www.google.com",
        },
        {
            id: 15,
            title: "Fake Chart 15",
            typeLabel: RecommendedChartTypeEnum.Mac,
            link: "https://www.google.com",
        },
    ];

    hasData = true;
    permissionLevel = PermissionLevelEnum.None;
    data: IRecommendedChart[] = [];

    constructor(data?: iData) {
        if (data?.apiModel) {
            this.mapFromApi(data.apiModel, data.searchQuery);
        }
    }

    private setData(model: iFoodProfileRecommendedCharts
    ) {
        ({
            permissionLevel: this.permissionLevel,
            hasData: this.hasData,
            data: this.data,
        } = model);
    }

    private mapFromApi(rawData: API_Model, searchQuery: string) {
        this.setData(new RecommendedCharts({
            apiModel: rawData,
            searchQuery,
        }));
    }
}